export default "__VITE_ASSET__DWHjCgwS__"